import * as React from "react";
import { CircleIcon } from "@primer/octicons-react";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from "@mui/lab";
import { Divider, Typography } from "@mui/material";
import labStyle from "./lab-styles";
import styles from "./lab.module.scss";
import useClientLabs from "../../../common/hooks/useClientLabs";
import Spinner from "../../../common/components/spinner";
import { ILabRecord, TestTypes } from "../../../../interfaces/Lab";
import LabStatusChip from "../../../../containers/Lab/LabStatusChip";
import { getTurnAroundTime } from "../../../../containers/Lab/ListTab";
import LabDetails from "../../../../containers/Lab/LabDetails";

const LabRow = React.memo(
  ({ row }: { row: ILabRecord }): React.JSX.Element => (
    <div className={styles.labRow}>
      <Typography>{row.labTestNumber}</Typography>
      <Divider className={styles.divider} orientation="vertical" variant="middle" flexItem />
      <Typography>{row?.results?.data?.map((test) => test.name).join(", ")}</Typography>
      <Divider className={styles.divider} orientation="vertical" variant="middle" flexItem />
      <LabStatusChip status={row.status?.toLowerCase()} />
      <Divider className={styles.divider} orientation="vertical" variant="middle" flexItem />
      <Typography>{getTurnAroundTime(row)}</Typography>
    </div>
  )
);
const Lab = (): React.JSX.Element => {
  const { isLoading, labs } = useClientLabs();

  const [selectedLab, setSelectedLab] = React.useState<ILabRecord | null>(null);

  if (isLoading) return <Spinner />;
  return (
    <div className={styles.labContainer}>
      {Object.keys(labs).map((key) => {
        const mapKey = key;
        return (
          <Timeline sx={labStyle.timeLine} key={mapKey}>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot variant="filled" className={styles.timelineDot}>
                  <CircleIcon className={styles.circleIcon} />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent className={styles.headerContent}>{key}</TimelineContent>
            </TimelineItem>
            {labs[key].map((lab) => {
              const billId = lab.id;
              return (
                <TimelineItem
                  key={billId}
                  className={styles.labRecord}
                  onClick={() => setSelectedLab(lab)}
                >
                  <TimelineSeparator>
                    <TimelineDot variant="outlined" className={styles.dotBorder}>
                      <LibraryBooksIcon />
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent className={styles.content}>
                    <LabRow row={lab} />
                  </TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        );
      })}

      {selectedLab && (
        <LabDetails
          labRecordType={TestTypes.CYTOLOGY}
          editMode={false}
          setEditMode={() => ({})}
          labObj={selectedLab}
          labId={selectedLab.id}
          handleViewClose={() => setSelectedLab(null)}
          navigateTo={() => ({})}
        />
      )}
    </div>
  );
};

export default Lab;
